import React from 'react'

const Footer = () => {
  return (
    <footer>
        <div>
            <h1>Tech Dev</h1>
            <p>Make yourself comfortable</p>
        </div>

        <div>
            <h5>Follow us</h5>
            <a href="https://www.instagram.com/so_you_me_/">Instagram</a>
            <a href="https://github.com/soumibiswas2002">Github</a>
            <a href="https://www.linkedin.com/in/soumi-biswas2002/">Linkedln</a>
        </div>
    </footer>
  )
}

export default Footer